import Link from 'next/link';
import PropTypes from 'prop-types';
import styles from './breadcrumbs.module.scss';

export default function Breadcumbs({ links = [], backLink = false }) {
  return (
    <div className={styles.breadcumbs}>
      <ul
        itemScope
        itemType="https://schema.org/BreadcrumbList"
        className={styles.breadcumbsList}
      >
        {links?.map((link, index) => (
          <li
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
            key={link.label}
          >
            <Link
              itemProp="item"
              href={link.link}
              className={`${styles.link} ${
                backLink && index === 0 ? styles.backLink : ''
              }`}
              data-testid={link.label}
            >
              <span itemProp="name">{link.label}</span>
            </Link>
            <meta itemProp="position" content={index + 1} />
          </li>
        ))}
      </ul>
    </div>
  );
}

Breadcumbs.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
    })
  ),
  backLink: PropTypes.bool,
};
